import * as React from 'react'
import moment from 'moment'
import * as _ from 'lodash'
import { copyObject, randomId } from '../../../../utils'
import { isEqualDates } from '../../../../utils/utilsT'

import { VariablesObj } from '../../../../types/Company'

import { InvoiceWorkerT, JobWorkerT } from '../../../../types/JobWorker'
import { getJobDuration, getMinimumTime } from '../JobUtils'
import { ActivityInvoiceT, ActivityT, JobT, LocationT } from '../../../../types/Job'


/**
 * activityIsValid
 * @param activity 
 * @returns boolean
 */
export const activityIsValid = (activity: ActivityT): boolean => {
    return activity.activityDate && activity.activityDate != ''
        && activity?.activityType != "" && activity?.startTime
        && activity?.startTime != ''
        && activity?.endTime && activity?.endTime != ''
}

/**
 * 
 * @param date 
 * @returns number
 */
export const dateToValueOf = (date): number => {
    return moment(date).utc().valueOf()
}


/**
 * 
 * @param startTime 
 * @param endTime 
 * @returns number
 */
export const getDurationHours = (startTime, endTime): number => {
    let _startTime = moment(startTime).utc()
    let _endTime = moment(endTime).utc()
    let between = _endTime.diff(_startTime, "seconds")
    let durationHours = 0
    if (between > 0) {
        // add +1 because function diff return minues 1
        between = between + 1
        durationHours = (between / 60) / 60
        durationHours = durationHours < 1 ? 1 : _.round(durationHours)
    }
    return durationHours
}

/**
 * 
 * @param locations 
 * @returns Array<ActivityInvoiceT>
 */
export const getActivitiesInvoice = (locations: Array<LocationT>): Array<ActivityInvoiceT> => {
    const activitiesItems = []
    // const activitesEmpty = []
    locations.map((location, index) => {
        const activities: Array<ActivityT> = _.isArray(location.activities) ? location.activities : []

        activities.map((activity, index) => {

            if (activityIsValid(activity)) {

                let finActivityDate = activitiesItems.find((date, index) => isEqualDates(date.activityDate, activity.activityDate))

                if (finActivityDate) {
                    let findindex = activitiesItems.findIndex((date, index) => isEqualDates(date.activityDate, activity.activityDate))
                    const startTime = dateToValueOf(finActivityDate.startTime) < dateToValueOf(activity.startTime) ? finActivityDate.startTime : activity.startTime
                    const endTime = dateToValueOf(finActivityDate.endTime) > dateToValueOf(activity.endTime) ? finActivityDate.endTime : activity.endTime

                    const findItem = Object.assign({}, activitiesItems[findindex])
                    let id = !_.has(findItem, "id") || !findItem.id ? randomId(12) : findItem.id
                    activitiesItems[findindex] = {
                        ...findItem, ...{
                            // id: id,
                            startTime: startTime,
                            endTime: endTime,
                            duration: getDurationHours(startTime, endTime),
                            isValid: true,
                        }
                    }
                } else {
                    let duration = getDurationHours(activity.startTime, activity.endTime)
                    let id = !_.has(activity, "id") || !activity.id ? randomId(12) : activity.id
                    activitiesItems.push({
                        ...activity, ...{
                            duration: duration,
                            isValid: true,
                            // id: id
                        }
                    })
                }

            } else {
                // let id = !_.has(activity, "id") || !activity.id ? randomId(12) : activity.id
                activitiesItems.push({
                    ...activity, ...{
                        // id: id,
                        isValid: false
                    }
                })
            }
        })
    })
    return activitiesItems;

}
